import React from 'react';
import {StyledTable} from './StyledTable';
import PropTypes from 'prop-types';
import Spinner from '../Spinner';

const Table = ({
  loading = false,
  ...rest
}) => {
  return (
    <StyledTable
      {...rest}
      loading={{
        indicator: <Spinner size='small' />,
        spinning: loading
      }}
    />
  );
}

Table.propTypes = {
  loading: PropTypes.bool
}

export default Table;
